import React from 'react';
import { Link } from 'react-router-dom';

// Body excerpt — strips whitespace, takes first N chars.
function excerpt(body, max = 120) {
  if (!body) return '';
  const trimmed = body.replace(/\s+/g, ' ').trim();
  return trimmed.length > max ? trimmed.slice(0, max) + '…' : trimmed;
}

// Date display — shows YYYY-MM-DD for posts older than 24h, or "N시간 전"
function relativeDate(iso) {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  const diffMs = Date.now() - then;
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  if (hours < 1) return '방금 전';
  if (hours < 24) return `${hours}시간 전`;
  return iso.slice(0, 10);
}

// Card preview for a single post. Click → /community/post/:id.
export default function PostCard({ post }) {
  const thumb = Array.isArray(post.imageUrls) && post.imageUrls.length > 0
    ? post.imageUrls[0]
    : null;
  return (
    <Link
      to={`/community/post/${encodeURIComponent(post.postId)}`}
      style={{
        display: 'flex',
        gap: 14,
        padding: '16px 18px',
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        textDecoration: 'none',
        color: 'inherit',
        transition: 'border-color 0.15s, transform 0.15s',
      }}
      onMouseEnter={e => (e.currentTarget.style.borderColor = 'var(--primary)')}
      onMouseLeave={e => (e.currentTarget.style.borderColor = 'var(--border)')}
    >
      {thumb && (
        <img
          src={thumb}
          alt=""
          style={{
            width: 80, height: 80, objectFit: 'cover',
            borderRadius: 8, flexShrink: 0,
          }}
          loading="lazy"
          decoding="async"
        />
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <h3 style={{
          margin: '0 0 8px 0', fontSize: '1.05rem', fontWeight: 600,
          color: 'var(--text)',
        }}>
          {post.title}
        </h3>
        <p style={{
          margin: '0 0 12px 0', fontSize: '0.9rem',
          color: 'var(--text-muted)', lineHeight: 1.5,
        }}>
          {excerpt(post.body)}
        </p>
        <div style={{
          display: 'flex', justifyContent: 'space-between',
          fontSize: '0.78rem', color: 'var(--text-dim)',
        }}>
          <span>{post.nickname || '익명'}</span>
          <span>
            {post.commentCount > 0 && (
              <span style={{ marginRight: 8 }}>💬 {post.commentCount}</span>
            )}
            {relativeDate(post.createdAt)}
          </span>
        </div>
      </div>
    </Link>
  );
}
